const ExcelOrder = () => {
  return <div>Excel Order</div>;
};

export default ExcelOrder;
